import { $, w } from './constants';
import { trackEvent } from './gtm.js';

const audio = document.getElementById('audio');
const progress = document.getElementById('progress');
const playPause = document.getElementById('playPause');
const time = document.getElementById('time');

if (audio && progress && playPause && time) {
	let hasPlayed = false;

	// Helpers
	function formatTime(seconds) {
		if (isNaN(seconds)) {
			return '00:00';
		}

		const minutes = Math.floor(seconds / 60);
		const secs = Math.floor(seconds % 60).toString().padStart(2, '0');
		return `${minutes}:${secs}`;
	}

	function setProgressFill(percent) {
		progress.style.background = `
			linear-gradient(
				to right,
				#ffffff 0%,
				#ffffff ${percent}%,
				#21009B ${percent}%,
				#21009B 100%
			)
		`;
	}

	function updateTimeDisplay() {
		const current = formatTime(audio.currentTime);
		const total = formatTime(audio.duration);
		time.textContent = `${current} / ${total}`;
	}

	function updateProgressBar() {
		if (!audio.duration) {
			return;
		}

		const percent = (audio.currentTime / audio.duration) * 100;

		progress.value = percent;
		setProgressFill(percent);
		updateTimeDisplay();
	}

	// Initial state
	setProgressFill(100);
	progress.value = 0;
	time.textContent = '00:00 / 00:00';

	// Play / Pause
	playPause.addEventListener('click', () => {
		if (!hasPlayed) {
			hasPlayed = true;
			setProgressFill(0);
		}

		if (audio.paused) {
			audio.play();
			playPause.textContent = '❚❚';
		} else {
			audio.pause();
			playPause.textContent = '▶';
		}
	});

	// Audio events
	audio.addEventListener('loadedmetadata', updateTimeDisplay);
	audio.addEventListener('timeupdate', updateProgressBar);

	audio.addEventListener('ended', () => {
		audio.currentTime = 0;
		playPause.textContent = '▶';
		hasPlayed = false;
		setProgressFill(100);
		progress.value = 0;
		time.textContent = '00:00 / 00:00';
	});

	// Seeking
	progress.addEventListener('input', () => {
		if (!audio.duration) {
			return;
		}

		if (!hasPlayed) {
			hasPlayed = true;
		}

		const percent = progress.value;
		audio.currentTime = (percent / 100) * audio.duration;

		setProgressFill(percent);
		updateTimeDisplay();
	});
}